import React, { useState } from 'react'; 
import EditPanel from './EditPanel';
import './ColorPlate.scss';
import pen from '../../assets/icons/pen.svg';

const ColorPlate = ({palette, id, load, darkTheme}) => {
    const [enableEdit, setEnableEdit] = useState(false);
    const {palette_name, color1, color2, color3, color4, color5} = palette
    const dark = {
        background: "#222831",
        color: "orange",
        borderRadius: "50px",
        boxShadow: '35px 35px 70px #1d222a, -35px -35px 70px #272e38'
    }

    const darkTitle = {
        color: "orange"
    }
    const closeModal = () => {
        setEnableEdit(false);
    }

    return (
        <div id={id} className="colorplate" style={(darkTheme) ? dark : null}>
        {
            (enableEdit) 
            ? <EditPanel load={load} id={id} palette={palette} close={closeModal} darkTheme={darkTheme}/> 
            : 
            <> 
                <div className="colorplate__top">
                    <h4 style={(darkTheme) ? darkTitle : null}className="colorplate__name">{palette_name}</h4>
                    <button className={(darkTheme) ? "colorplate__btn-dark" : "colorplate__btn"} onClick={() => setEnableEdit(true)}><img className="colorplate__btn-img"src={pen} alt="edit pen btn"/></button>
                </div>
                <div className="colorplate__wrap">
                    <div className="colorplate__each">
                        <div className="colorplate__box" style={{background: `${color1}`}}/>
                        <p style={(darkTheme) ? dark : null}className="colorplate__pill">{color1}</p>
                    </div>
                    <div className="colorplate__each">
                        <div className="colorplate__box" style={{background: `${color2}`}}/>
                        <p style={(darkTheme) ? dark : null}className="colorplate__pill">{color2}</p>
                    </div>
                    <div className="colorplate__each">
                        <div className="colorplate__box" style={{background: `${color3}`}}/>
                        <p style={(darkTheme) ? dark : null}className="colorplate__pill">{color3}</p>
                    </div>
                    <div className="colorplate__each">
                        <div className="colorplate__box" style={{background: `${color4}`}}/>
                        <p style={(darkTheme) ? dark : null}className="colorplate__pill">{color4}</p>
                    </div>
                    <div className="colorplate__each">
                        <div className="colorplate__box" style={{background: `${color5}`}}/>
                        <p style={(darkTheme) ? dark : null}className="colorplate__pill">{color5}</p>
                    </div>
                </div>
            </>
        }
        
            
        </div>
    )
}

export default ColorPlate
